function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRightArrowInBlueCircle = function SvgRightArrowInBlueCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-chevron-circle-right",
    d: "M7.563.563a7 7 0 1 1-7 7 7 7 0 0 1 7-7zm3.215 6.52L6.953 3.258a.675.675 0 0 0-.957 0l-.48.48a.675.675 0 0 0 0 .957l2.868 2.868-2.868 2.867a.675.675 0 0 0 0 .957l.48.48a.675.675 0 0 0 .957 0l3.825-3.825a.678.678 0 0 0-.001-.959z",
    transform: "translate(-.563 -.563)",
    style: {
      fill: "#196cca"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightArrowInBlueCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right_arrow_in_blue_circle.76d12019.svg";
export { ForwardRef as ReactComponent };